// Selección de causas del Fishbone (análisis de brecha). Las causas se identifican por gapAefCauseId,
// la pregunta del Fishbone; una misma pregunta cuenta una sola vez aunque llegue repetida.

export const MAX_SELECTED_CAUSES = 3;

const distinct = (ids) => [...new Set(ids)];

// Marca o desmarca una causa. Devuelve una lista nueva (no modifica la recibida) y si se intentó pasar del máximo.
export const toggleCause = (selectedIds, causeId, max = MAX_SELECTED_CAUSES) => {
    const current = distinct(selectedIds ?? []);

    if (current.includes(causeId)) {
        return { selectedIds: current.filter(x => x !== causeId), limitExceeded: false };
    }
    if (current.length >= max) {
        return { selectedIds: current, limitExceeded: true };
    }
    return { selectedIds: [...current, causeId], limitExceeded: false };
};

// Cambios a enviar al "Procesar selección": desactiva las causas guardadas que ya no están elegidas
// y agrega las elegidas que no están guardadas. Lo que no cambia no se envía.
export const buildCausesChanges = ({ savedCauses, selectedIds, gapAnalyzeId }) => {
    const selected = distinct(selectedIds ?? []);
    const saved = savedCauses ?? [];
    const savedIds = saved.map(x => x.gapAefCauseId);

    const removed = saved
        .filter(x => !selected.includes(x.gapAefCauseId))
        .map(x => ({
            id: x.id,
            gapAnalyzeId: gapAnalyzeId,
            gapId: x.gapId,
            gapAefCauseId: x.gapAefCauseId,
            rootCause: x.rootCause ?? false,
            priority: x.priority ?? null,
            statusId: x.statusId ?? 0,
            deactivate: true,
            l_action: [],
        }));

    const added = selected
        .filter(id => !savedIds.includes(id))
        .map(id => ({
            id: 0,
            gapAnalyzeId: gapAnalyzeId,
            gapId: 0,
            gapAefCauseId: id,
            rootCause: false,
            priority: null,
            statusId: 0,
            deactivate: false,
            l_action: [],
        }));

    return [...removed, ...added];
};
